// src/routes/DropshippingRoutes.jsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PermissionRoute from './PermissionRoute';

import DropshippingSettingsPage from '../pages/dropshipping/DropshippingSettingsPage';
import DropshippingProductsPage from '../pages/dropshipping/DropshippingProductsPage';
import ResellerRequestsPage from '../pages/dropshipping/ResellerRequestsPage';
import DropshippingInvoiceListPage from '../pages/dropshipping/DropshippingInvoiceListPage';
import DropshippingInvoiceDetailPage from '../pages/dropshipping/DropshippingInvoiceDetailPage';

const DropshippingRoutes = () => {
  return (
    <Routes>
      <Route
        path="settings"
        element={
          <PermissionRoute requiredPermission="manage_dropshipping_settings">
            <DropshippingSettingsPage />
          </PermissionRoute>
        }
      />
      <Route
        path="products"
        element={
          <PermissionRoute requiredPermission="view_dropshipping_products">
            <DropshippingProductsPage />
          </PermissionRoute>
        }
      />
      <Route
        path="requests"
        element={
          <PermissionRoute requiredPermission="manage_dropshipping_requests">
            <ResellerRequestsPage />
          </PermissionRoute>
        }
      />
      <Route
        path="invoices"
        element={
          <PermissionRoute requiredPermission="view_dropshipping_invoices">
            <DropshippingInvoiceListPage />
          </PermissionRoute>
        }
      />
      <Route
        path="invoices/:id"
        element={
          <PermissionRoute requiredPermission="view_dropshipping_invoices">
            <DropshippingInvoiceDetailPage />
          </PermissionRoute>
        }
      />
    </Routes>
  );
};

export default DropshippingRoutes;
